// @flow

import React from 'react';

export const Label = (props: any) => React.createElement('label', { className: 'field__label field__label--visible', ...props });
